import { Form, Dropdown, Select, Label } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const renderTextField = ({
  input,
  label,
  type,
  fieldValue,
  value,
  disabled,
  meta: { asyncValidating, touched, error },
}) => {
  // Define a variable to conditionally set the class name
  // const inputClassName = disabled === "true" ? "black-text" : "";

  return (
    <>
      <Form>
        <Form.Field>
          <div className={asyncValidating ? "async-validating" : ""}>
            <Form.Input
              error={touched && error && { content: error, pointing: "below" }}
              label={label}
              {...input}
              // value={value}
              type={type}
              placeholder={label}
              disabled={disabled === "true" ? disabled : ""}
              // Apply the class conditionally
            />
          </div>
        </Form.Field>
      </Form>
    </>
  );
};

const renderTextAreaField = ({
  input,
  label,
  type,
  fieldValue,
  value,
  disabled,
  rows,

  meta: { asyncValidating, touched, error },
}) => (
  <>
    <Form>
      <Form.Field>
        <div className={asyncValidating ? "async-validating" : ""}>
          <Form.TextArea
            error={touched && error && { content: error, pointing: "below" }}
            label={label}
            {...input}
            type={type}
            rows={rows || 6}
            style={{ minHeight: "8em", resize: "vertical" }}
            placeholder={label}
            disabled={disabled === "true" ? disabled : ""}
          />
        </div>
      </Form.Field>
    </Form>
  </>
);
const renderTextFieldPreValue = ({
  input,
  label,
  type,
  fieldValue,
  value,
  disabled,

  meta: { asyncValidating, touched, error },
}) => (
  <>
    <Form>
      <Form.Field>
        <div className={asyncValidating ? "async-validating" : ""}>
          <Form.Input
            error={touched && error && { content: error, pointing: "below" }}
            label={label}
            {...input}
            type={type}
            value={fieldValue != "" ? fieldValue : input.value}
            placeholder={label}
            disabled={disabled === "true" ? disabled : ""}
          />
        </div>
      </Form.Field>
    </Form>
  </>
);

const renderOptionField = ({
  label,
  options,
  input,
  disabled,
  meta: { asyncValidating, touched, error },
}) => (
  <>
    <Form.Field>
      <div className={asyncValidating ? "async-validating" : ""}>
        <Form.Dropdown
          error={touched && error && { content: error, pointing: "below" }}
          fluid
          search
          selection
          placeholder={label}
          options={options}
          disabled={disabled === true || disabled === "true"}
          label={{
            children: label,
            htmlFor: "form-select-control",
          }}
          value={input.value}
          onChange={(e, { value }) => input.onChange(value)}
          // dropdownRender={(menu) => <div style={{ zIndex: 9999 }}>{menu}</div>}
        />
      </div>
    </Form.Field>
  </>
);

const renderRadioField = ({
  input,
  radioValue,
  label,
  name,

  meta: { asyncValidating, touched, error },
}) => (
  <Form.Radio
    error={touched && error && { content: error, pointing: "below" }}
    checked={input.value === radioValue}
    label={label}
    name={name}
    onChange={(e, { checked }) => input.onChange(radioValue)}
  />
);

const renderCheckbox = (field) => (
  <Form.Checkbox
    checked={!!field.input.value}
    name={field.input.name}
    label={field.label}
    onChange={(e, { checked }) => field.input.onChange(checked)}
  />
);

const renderDatePicker = ({
  input,
  placeholder,
  minDate,
  maxDate,
  label,
  icon,
  holydays,
  enabledDates,
  meta: { asyncValidating, touched, error },
}) => {
  const CustomeInputField = ({ date, value, onChange, onClick }) => (
    <Form>
      <Form.Field>
        <div className={asyncValidating ? "async-validating" : ""}>
          <Form.Input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="form-control"
            onClick={onClick}
            label={label}
          />
          <span className="input-group-addon">
            <span className="glyphicon glyphicon-calendar" />
          </span>
        </div>
      </Form.Field>
    </Form>
  );

  console.log("holy days", holydays);
  return (
    <div>
      <div className="single-widget-search-input-title"></div>
      <DatePicker
        className="plus-icon"
        dateFormat="yyyy/MM/dd"
        selected={input.value || null}
        onChange={input.onChange}
        minDate={minDate}
        maxDate={maxDate}
        excludeDates={holydays}
        disabledKeyboardNavigation
        placeholderText={placeholder}
        includeDates={enabledDates} // Specify the enabled dates here
        customInput={<CustomeInputField />}
      />
      <div className="err-msg">{touched && error && <span>{error}</span>}</div>
    </div>
  );
};


const renderOptionFreeField = ({
  label,
  options,
  input,
  disabled,
  meta: { asyncValidating, touched, error },
}) => {
  const handleAddition = (e, { value }) => {
    if (!options.some(option => option.text === value || option.value === value)) {
      options.push({ key: value, text: value, value });
    }
  };

  return (
    <Form.Field>
      <div className={asyncValidating ? "async-validating" : ""}>
        <Form.Dropdown
          error={touched && error && { content: error, pointing: "below" }}
          fluid
          search
          selection
          allowAdditions
          additionLabel="Add: "
          placeholder={label}
          options={options}
          disabled={disabled === true || disabled === "true"}
          label={{
            children: label,
            htmlFor: "form-select-control",
          }}
          value={input.value}
          onChange={(e, { value }) => input.onChange(value)}
          onAddItem={handleAddition}
        />
      </div>
    </Form.Field>
  );
};

export {
  renderTextField,
  renderOptionField,
  renderRadioField,
  renderCheckbox,
  renderTextFieldPreValue,
  renderTextAreaField,
  renderDatePicker,
  renderOptionFreeField
};
